import * as React from "react"
import { createStore, applyMiddleware, compose } from "redux"
import { Provider } from "react-redux"
import { persistStore, persistReducer } from "redux-persist"
import { PersistGate } from "redux-persist/lib/integration/react"
import thunk from "redux-thunk"
import { IStoreFactory, ActionType } from "../interfaces/storeFactory"
import mbUrl from '../modules/mbUrl'

/**
 * The StoreFactory creates the Redux store and a persistance layer as defined in the configuration file.
 * The child elements are wrapped in a Redux Provider.
 */
const enhancer = mbUrl.getEnvironment() !== 'development' ? compose(applyMiddleware(thunk)) : window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()



export default ({ config, children }: IStoreFactory) => {
    const { reducers, initialState, persistConfig } = config

    if (persistConfig) {
        const reducer = persistReducer(persistConfig, reducers)
        const store = createStore(reducer, initialState, enhancer)
        const persistor = persistStore(store)

        return (
            <Provider store={store}>
                <PersistGate persistor={persistor}>
                    {children}
                </PersistGate>
            </Provider>
        )
    }
    else {
        const store = createStore(reducers, initialState, enhancer)
        return (
            <Provider store={store}>
                {children}
            </Provider>
        )
    }
}


/**
 * Generic reducer funtion that can be used for many basic redux reducers.
 * @param previousState Previous or initial state.
 * @param action Action object that must include the action type as string and the changes to the previousSate in a payload object.
 * @param supportedActions List of supported action type.
 */
export const updateState = <T extends object, U extends ActionType<T>>(previousState: T, action: U, supportedActions: string[]) => {
    if (0 <= supportedActions.indexOf(action.type)) {
        return Object.assign({}, previousState, action.payload)
    }
    else {
        return previousState
    }
}